import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { SessionService } from '../../../store/session/state/session.service';
import { MatDialogRef } from '@angular/material/dialog';
import { SessionQuery } from '../../../store/session/state/session.query';
import { SubSink } from 'subsink';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AircraftService } from 'src/app/store/aircraft/state/aircraftService';

@Component({
  selector: 'app-login-popup',
  templateUrl: './login-popup.component.html',
  styleUrls: ['./login-popup.component.scss'],
})
export class LoginPopupComponent implements OnInit, OnDestroy {
  hide = true;
  loginForm = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required],
  });
  subs = new SubSink();
  loading = false;

  constructor(
    private fb: FormBuilder,
    private service: SessionService,
    private query: SessionQuery,
    private snackbar: MatSnackBar,
    private dialogRef: MatDialogRef<LoginPopupComponent>,
    private aircraftService: AircraftService
  ) {}

  ngOnInit() {
    this.subs.sink = this.query.select().subscribe((state) => {
      if (state.token !== null) {
        this.dialogRef.close();
      }
    });
  }

  login() {
    this.loading = true;
    this.subs.sink = this.service.login(this.loginForm.value).subscribe(
      () => {
        this.loading = false;
        this.getbeacons();
      },
      () => {
        this.loading = false;
        this.snackbar.open('Bejelentkezés sikertelen');
      }
    );
  }

  getbeacons() {
    this.subs.sink = this.aircraftService.getAircrafts().subscribe();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
